import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { polarisProductGlobalFieldsSettingsEntryPoint } from '@atlassian/jira-spa-apps-polaris-settings-global-fields/entrypoint.tsx';

export const polarisProductGlobalFieldsSettingsPageEntryPoint = createPageEntryPoint({
	main: polarisProductGlobalFieldsSettingsEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});
